export default __webpack_public_path__ + "static/media/hands-phone.adffeb10.svg";